import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext.js'
import Layout from './components/Layout.js'
import Login from './pages/Login.js'
import Dashboard from './pages/Dashboard.js'
import Users from './pages/Users.js'
import Regions from './pages/Regions.js'
import Notifications from './pages/Notifications.js'
import Banners from './pages/Banners.js'
import Logs from './pages/Logs.js'
import Settings from './pages/Settings.js'
import ProtectedRoute from './components/ProtectedRoute.js'

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="users" element={<Users />} />
            <Route path="regions" element={<Regions />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="banners" element={<Banners />} />
            <Route path="logs" element={<Logs />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App
